import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Typography, Divider, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import ReactPlayer from "react-player";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function Player() {
  const [expanded, setExpanded] = React.useState(false);
  const [cickPreview, setCickPreview] = React.useState(false);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
      sx={{ p: 0, width: "fit-content", mx: "auto" }}
    >
      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <Typography sx={{ fontSize: "14px" }}>اوملنگ چیه؟</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ReactPlayer
          controls={true}
          className="react-player"
          url="https://umlang.com/video/newVideo/201.mp4"
          light={
            <img
              src="https://umlang.com/video/img/201.png"
              alt="Thumbnail"
              style={{
                border: "double 6px",
                borderRadius: "45px",
                opacity: "0.5",
              }}
            />
          }
          width={expanded !== "panel1" ? "250px" : cickPreview ? null : "250px"}
          height={
            expanded !== "panel1" ? "250px" : cickPreview ? null : "250px"
          }
          onEnded={handleChange("panel1")}
          onClickPreview={(e) => {
            setCickPreview(true);
          }}
          playing={true}
        />
      </AccordionDetails>
    </Accordion>
  );
}
